module.exports = __webpack_public_path__ + "static/img/LiLunKS.2be895c0.png";